import { LayoutInterval } from '../interfaces/LayoutInterval';

/** Shrinks the first interval so it is withing the bounds of the second interval */
export function shrink(a: LayoutInterval, b: LayoutInterval): void {
    a.start = Math.max(a.start, b.start);
    a.end = Math.min(a.end, b.end);
}
